function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.3001 8.70001C9.15567 8.50744 9.08555 8.26923 9.10261 8.02912C9.11968 7.78901 9.22278 7.56311 9.39299 7.3929C9.5632 7.22269 9.7891 7.11959 10.0292 7.10252C10.2693 7.08546 10.5075 7.15558 10.7001 7.30001L14.7001 11.3C14.8833 11.4869 14.986 11.7383 14.986 12C14.986 12.2618 14.8833 12.5131 14.7001 12.7L10.7001 16.7C10.5075 16.8444 10.2693 16.9146 10.0292 16.8975C9.7891 16.8804 9.5632 16.7773 9.39299 16.6071C9.22278 16.4369 9.11968 16.211 9.10261 15.9709C9.08555 15.7308 9.15567 15.4926 9.3001 15.3L12.5901 12L9.2901 8.70001H9.3001Z"
});

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.dc561711.svg";
export { ForwardRef as ReactComponent };